import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { AgentUtility } from '../../../util';
import { AgentsService } from '../../../services/agents.service';

@Component({
  selector: 'app-orgstructure-new',
  templateUrl: './orgstructure-new.component.html',
  styleUrls: ['./orgstructure-new.component.css']
})
export class OrgstructureNewComponent implements OnInit {

  activenodes: any[] = [];
  nodes: any[] = [];
  showfilter: boolean = false;
  @Output() onSelect:EventEmitter<any[]> = new EventEmitter<any[]>();

  @ViewChild("filter_input",{static: false}) input:ElementRef;

  constructor(
    private agentService: AgentsService) { }

  ngOnInit() {
    this.getAgents();
  }

  get ActiveNodes() {
    function sortNodes(firstNode, secondNode) {
        return firstNode.index - secondNode.index
    }

    if (this.activenodes.length > 1)
        this.activenodes.sort(sortNodes);

    return this.activenodes.map(x => x.data.Name).join(', ');
  }

  
  active(node) {
    node.data.isChoose = !node.data.isChoose;
    this.expandAndActivate(node);
    this.onSelect.emit(this.activenodes.map(n => n.data))
  }

  

  expandAndActivate(node) {
    if (node.data.isChoose && !node.isExpanded)
        node.expand();
    if (!node.data.isChoose && node.isExpanded)
        node.collapse();
    this.searchForAgents(node);
    node.IsClickedBefore = true;
    if (node.children && node.children.length > 0) {
        for (let i = 0; i < node.data.children.length; i++) {
            if (!(node.children[i].IsClickedBefore)) {
                node.children[i].data.isChoose = node.data.isChoose;
                this.expandAndActivate(node.children[i]);
            }

            if (node.children[i].data.isChoose == node.data.isChoose)
                continue;

            node.children[i].data.isChoose = node.data.isChoose;
            if (node.children[i].data.isChoose == false)
                this.searchForAgents(node.children[i], false);
            else
                this.searchForAgents(node.children[i]);
        }
    } else {
        node.children = [];
    }
  }

  searchForAgents(node, choosen = true) {
    let currentUser = AgentUtility.getUser();
    let index = this.activenodes.findIndex(x => x.id == node.id);
    if (index == -1 && !choosen)
        return;
    if (index >= 0) {
        this.activenodes.splice(index, 1);
    } else {
        if (currentUser.Id != node.data.Id) {
            this.activenodes.push(node);
        }
    }
}

  getAgents(){
    let Id = AgentUtility.getUser().Id;
    this.agentService.getAgentTreeByFilter(Id, { downOnly: true }).subscribe(res => {
        let data = res.data;
        data[0].isParent = true;
        this.nodes = data;
    });
  }

  get TreeWidth():number{
    return this.input.nativeElement.clientWidth - 10
  }
}

